import React, { useEffect } from 'react';

import { ApolloProvider } from '@apollo/client';
import GlobalStyles from 'assets/styles/Global';
import { removePrivallyOptionBar } from 'utils/privallyUtils';

import AppProvider from './hooks/AppProvider';
import Routes from './routes';
import { client } from './services';

function App() {
  useEffect(() => {
    removePrivallyOptionBar();
  }, []);

  return (
    <AppProvider>
      <ApolloProvider client={client}>
        <GlobalStyles />
        <Routes />
      </ApolloProvider>
    </AppProvider>
  );
}

export default App;
